export default function (el, binding) {
    el.setAttribute('lat', binding.value.location.coordinates[1]);
    el.setAttribute('lng', binding.value.location.coordinates[0]);
}